import _, { initial } from 'lodash';
import { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, MenuItem } from '@material-ui/core';
import { normalizeNumeral } from '../../utils/general/general-utils';
import QCXFinalFormDialog from '../../shared-components/dialog/QCXFinalFormDialog';
import QCXFinalAlternativeCurrencyField from '../../shared-components/final-currency-field/QCXFinalAlternativeCurrencyField';
import QCXFinalDatePickerField from '../../shared-components/final-date-picker-field/QCXFinalDatePickerField';
import QCXSelectContaBancariaAutocompleteField from '../../shared-components/select-conta-bancaria/QCXSelectContaBancariaAutocompleteField';
import { CLOSED_STATUS, isOpenStatus } from '../../utils/hooks/form/dialog/formDialogUtils';
import QCXFinalTextFieldAlt from '../../shared-components/final-text-field/QCXFinalTextFieldAlt';

export default function QCXPartialValuesDialogForm({
  handleOnSubmit,
  handleFormStatus,
  formDialogStatus,
  isSingleItemSelected,
  initialValues,
}) {
  const { t } = useTranslation();
  const isFormDialogOpen = isOpenStatus(formDialogStatus);

  const handleCloseFormDialogNew = useCallback(() => {
    handleFormStatus(CLOSED_STATUS);
    _.debounce(() => {}, 200)();
  }, [handleFormStatus]);

  return (
    <QCXFinalFormDialog
      key="form-dialog-relatorio-conta-pagar-receber"
      id="form-dialog-relatorio-conta-pagar-receber"
      title="Receber Valor Parcial"
      dialogActionsProps={{
        button: {
          submit: { description: 'Receber', size: 'small', color: 'secondary' },
          cancel: { description: t('com.muralis.qcx.acoes.cancelar'), size: 'small' },
        },
      }}
      open={isFormDialogOpen}
      initialValues={{
        ...initialValues,
      }}
      onSubmit={handleOnSubmit}
      onClose={handleCloseFormDialogNew}
    >
      {({ values }) => {
        const saldoInicial = normalizeNumeral(initialValues?.valorSaldoInicial ?? 0);
        const valorParcialNumero = normalizeNumeral(values?.valorParcial ?? 0);
        const showSaldoAbertoSelect = isSingleItemSelected && valorParcialNumero < normalizeNumeral(initialValues?.valorAtual ?? 0);

        return (
          <>
            <Grid>
              <QCXFinalAlternativeCurrencyField
                name="valorParcial"
                label="Valor Recebido"
                required
                disabled={!isSingleItemSelected}
              />
            </Grid>
            <Grid style={{ paddingTop: '1rem' }}>
              <QCXFinalDatePickerField name="dataPagamento" label="Data de Recebimento" required />
            </Grid>
            <Grid style={{ paddingTop: '1rem' }} item xs={12} sm={12} md={12} lg={12}>
              <QCXSelectContaBancariaAutocompleteField
                id="select-conta-bancaria"
                name="contaBancariaId"
                label="Conta Bancária"
                filtraControlaSaldo
                required
              />
            </Grid>
            <Grid style={{ paddingTop: '1rem' }} item xs={12}>
              <QCXFinalTextFieldAlt
                style={{ display: showSaldoAbertoSelect ? 'block' : 'none' }}
                select
                label="Deseja manter o saldo aberto?"
                name="manterSaldoAberto"
                fullWidth
              >
                <MenuItem value="SIM">Sim</MenuItem>
                <MenuItem value="NAO">Não</MenuItem>
              </QCXFinalTextFieldAlt>
            </Grid>
          </>
        );
      }}
    </QCXFinalFormDialog>
  );
}
